import AuthRequest from '@/shared/infrastructure/auth/Request'

const actions = {
  async fetchCategories({ commit }) {
    const response = await AuthRequest.fetchCategories()
    commit('setCategories', response.categories)
  },
  async registerFreelancer({ commit }, formData) {
    const response = await AuthRequest.registerFreelancer(formData)
    if (response.result) { 
      const payload = {
        userAuthInfo: {
          name: response.name,
          token: response.token,
          message: response.message,
          email: response.email,
          role: response.role,
          emailVerified : response.email_verified,
          profileVerified : response.profile_verified
        }
      }
      if (window.localStorage) {
        const vuexData = window.localStorage.vuex
          ? JSON.parse(window.localStorage.vuex)
          : {auth : {isUserLoggedIn: true, userAuthInfo: {} }}
        vuexData.auth.isUserLoggedIn = true
        vuexData.auth.userAuthInfo = payload.userAuthInfo
        window.localStorage.setItem("vuex", JSON.stringify(vuexData))
      }
      commit('userLoggedInFromVuex', payload)
    }
    return response
  },
  userLoggedIn({ commit }, payload) {
    commit('userLoggedIn', payload)
  },
  userLoggedInFromVuex({commit}, payload) {
    commit('userLoggedInFromVuex', payload)
  },
  async logout({ commit, state }) {
    const response = await AuthRequest.logout(state.userAuthInfo.token)
    commit('userLoggedOut')
    commit('setProfileStatus', false)
    commit('setProfileActivationStatus', false)
    return response
  },
  resendAccountVerificationEmail() {
    return AuthRequest.resendAccountVerificationEmail()
  },
  verifyEmail({ state }, payload) {
    payload.isUserLoggedIn = state.isUserLoggedIn 
    return AuthRequest.verifyEmail(payload)
  },
  async checkProfileStatus({ commit, state }) {
    if (!state.isUserLoggedIn) return
    const response = await AuthRequest.checkProfileStatus()
    commit('setProfileStatus', response.is_email_verified)
    commit('setProfileActivationStatus', response.is_active)
    commit('setUserEmail', response.email)
    return response
  },
  async validateAuthToken({ commit, state }) {
    if (!state.isUserLoggedIn) return
    const response = await AuthRequest.validateAuthToken()
    if (!response.result) commit('userLoggedOut')
  },
  async login({ commit }, payload) {
    const response = await AuthRequest.login(payload.formData)
    if (response.result) {
      commit('userLoggedIn', { response, rememberMe: payload.rememberMe })
      commit('openLoginModal', false)
    }
    return response
  },
  openAlertModal({ commit }, payload) {
    commit('openAlertModal', payload)
  },
  openLoginModal({commit}, payload) {
    commit('openLoginModal', payload)
  },
  openLoginSelectionModal({commit}, payload) {
    commit('openLoginSelectionModal', payload)
  },
  LoginSelectionMode({commit}, payload) {
    commit('LoginSelectionMode', payload)
  },
  openSignupSelectionModal({commit}, payload) {
    commit('openSignupSelectionModal', payload)
  },
  openForgetPasswordModal({commit}, payload) {
    commit('openForgetPasswordModal', payload)
  },
  forgotPassword(action, email) {
    return AuthRequest.forgotPassword(email)
  },
  loginWithLinkedIn() {
    return AuthRequest.loginWithLinkedIn()
  },
}

export default actions
